import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { muiBankTheme } from '../../tools/theme';
import { useButtonWidth } from './useButtonWidth';
import { useDerivedSize } from './useDerivedSize';
import { mapHexToColorName } from './utils';
export const useAction = (actionType, disableFullWidthSmDown, fullWidthMd, variant, size) => {
    const safeVariant = actionType === 'link' ? variant || 'link' : variant || 'primary';
    const derivedSize = useDerivedSize(safeVariant, variant !== 'link' ? size : undefined);
    const { width } = useButtonWidth(safeVariant, !!disableFullWidthSmDown, !!fullWidthMd, actionType === 'link' ? derivedSize : undefined);
    // Theme provides the color hex value, but Icon needs the color name
    // So we find the color name that maps to the hex value
    const iconFill = useMemo(() => { var _a; return mapHexToColorName((_a = muiBankTheme.buttons[safeVariant]) === null || _a === void 0 ? void 0 : _a.color); }, [safeVariant]);
    const theme = useTheme();
    return {
        safeVariant,
        derivedSize,
        width,
        iconFill,
        theme,
    };
};
//# sourceMappingURL=useAction.js.map